export const TasksVersions = {
    Version1: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7 },
        { id: 8 },
        { id: 9 },
        { id: 10 },
        { id: 11 },
        { id: 12 },
        { id: 13 },
    ],
    Version2: [
        { id: 7 },
        { id: 8 },
        { id: 9 },
        { id: 10 },
        { id: 11 },
        { id: 12 },
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
    ]
}

export const TaskType = {
    'RATING': { id: 16  , type: 'Rating' }
}

export const SubTaskType = {
    'PRACTICE': { id: 1, type: 'practice' },
    'TASKS': { id: 1, type: 'tasks' },
}

export const ProgressionType = {
    'Energy': 1,
    'Pleasant': 2
}
export const getTaskTypeIdByType = (type) => {
    const keys = Object.keys(TaskType);
    for (let index in keys) {
        const key = keys[index];
        if (TaskType[key].type === type) {
            return TaskType[key];
        }
    }
}

export const getTaskTypeIdById = (id) => {
    const keys = Object.keys(TaskType);
    for (let index in keys) {
        const key = keys[index];
        if (TaskType[key].id === id) {
            return TaskType[key];
        }
    }
}

export const getTasks = (data, type, subType) => {
    debugger;
    if (data) {
        const taskType = Object.values(data).find(task => task.id && task.id === type.id);

        if (taskType) {
            return taskType[subType.type];
        }
    }
}

export const getOutcomes = (data) => {
  if (data) {
    return data['outcomes'];
  }
}

export const TaskSegment = {
    'INSTRUCTION': 'Instruction',
    'PRACTICE': 'Practice',
    'PRACTICECOMPLETE': 'PracticeComplete',
    'TASK': 'Task'
};

export const getVersionIndex = (version, id) => {
    for (let index in version) {
        const item = version[index];
        if (item.id === id) {
            return parseInt(index);
        }
    }
}

export const getLang = (version) => {
    const langVersions = {
        en: [36, 37, 38, 39, 40, 41, 42, 43, 56, 57, 58, 59, 60, 67, 68, 69, 70, 71],
        fr: [44, 45, 46, 47, 48, 49, 61, 62, 63, 64, 65, 66, 72, 73, 74, 75, 76, 77],
        es: [50, 51, 52, 53, 54, 55, 78, 79, 80, 81, 82, 83]
    };
    const lang = Object.keys(langVersions).find(key => langVersions[key].includes(version));
    return lang;
}

export const translateLabel = (label, versionID) => {
    if (!label) {
        return;
    }
  
    const lang = getLang(versionID);
    let translatedLabel = label;
  
    switch (lang) {
        case 'fr':
            translatedLabel = translatedLabel.replace('OF', 'SUR');
            break;
  
        case 'es':
            translatedLabel = translatedLabel.replace('OF', 'DE');
            break;
  
        case 'en':
        default:
            break;
    }
  
    return translatedLabel;
  }
